import { render, staticRenderFns } from "./TuiViewer.vue?vue&type=template&id=70712e88"
import script from "./TuiViewer.vue?vue&type=script&lang=js"
export * from "./TuiViewer.vue?vue&type=script&lang=js"
import style0 from "./TuiViewer.vue?vue&type=style&index=0&id=70712e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports